<div class="doc-section">
    <div class="doc-card" #docCard>
        <style>
            .hip-page {
                font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                font-size: 10.5pt;
                font-weight: 400;
                line-height: 1.65;
                color: #000000;
            }

            .hip-header {
                background-color: #1a2c5b;
                padding: 0 32px;
                height: 52px;
                display: flex;
                align-items: center;
            }

            .hip-brand {
                font-size: 18pt;
                font-weight: 700;
                color: #ffffff;
                line-height: 1;
            }

            .hip-brand-accent {
                color: #f0b429;
            }

            .hip-gold-bar {
                height: 5px;
                background-color: #f0b429;
            }

            .hip-body {
                padding: 20px 80px;
            }

            .hip-title {
                text-align: center;
                font-weight: 700;
                font-size: 12pt;
                text-transform: uppercase;
                color: #000000;
                text-decoration: underline;
                margin-bottom: 4px;
            }

            .hip-subtitle {
                text-align: center;
                font-weight: 600;
                font-size: 11pt;
                color: #000000;
                margin-bottom: 18px;
            }

            .hip-p {
                margin-bottom: 10px;
                font-size: 10.5pt;
                color: #000000;
            }

            .hip-heading {
                font-weight: 700;
                font-size: 10.5pt;
                color: #000000;
                text-transform: uppercase;
                letter-spacing: 0.3px;
                margin-top: 18px;
                margin-bottom: 8px;
                padding-bottom: 4px;
                border-bottom: 1px solid #c7d4f0;
            }

            .hip-bold {
                font-weight: 700;
                color: #000000;
            }

            .hip-bold-u {
                font-weight: 700;
                text-decoration: underline;
                color: #000000;
            }

            .hip-recipients {
                background-color: #f0f4ff;
                border: 1px solid #c7d4f0;
                border-left: 4px solid #2a4494;
                padding: 10px 16px;
                margin: 10px 0;
            }

            .hip-recipients ul {
                margin-bottom: 0;
            }

            .hip-ul {
                margin-left: 20px;
                margin-top: 6px;
                margin-bottom: 10px;
            }

            .hip-ul li {
                margin-bottom: 5px;
                font-size: 10.5pt;
                color: #000000;
            }

            .hip-info-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 12px;
                border: 1px solid #d1d9ea;
            }

            .hip-info-table td {
                font-size: 10.5pt;
                padding: 10px 14px;
                border: 1px solid #d1d9ea;
                width: 50%;
                vertical-align: middle;
            }

            .hip-info-table td.lbl {
                background-color: #eef1f8;
                font-weight: 700;
                color: #000000;
            }

            .hip-info-table td.val {
                background-color: #ffffff;
                font-weight: 700;
                color: #000000;
                text-transform: capitalize;
            }

            .hip-sig-block {
                margin-top: 28px;
                margin-bottom: 20px;
                padding: 20px;
                background-color: #fafbfd;
                border: 1px solid #e2e8f0;
                border-top: 3px solid #1a2c5b;
            }

            .hip-sig-block-heading {
                font-weight: 700;
                font-size: 10pt;
                text-transform: uppercase;
                letter-spacing: 1px;
                color: #000000;
                margin-bottom: 10px;
            }

            .hip-intro {
                margin-bottom: 16px;
                font-size: 10.5pt;
                color: #000000;
            }

            .hip-sig-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 18px;
            }

            .hip-sig-table td {
                vertical-align: bottom;
                padding: 0;
            }

            .hip-sig-label {
                display: block;
                font-size: 8.5pt;
                font-weight: 700;
                color: #000000;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                margin-bottom: 5px;
            }

            .hip-sig-line {
                border-bottom: 1px solid #374151;
                height: 26px;
                display: block;
                width: 100%;
            }

            .hip-sig-value {
                border-bottom: 1px solid #374151;
                height: 26px;
                display: block;
                width: 100%;
                font-size: 10.5pt;
                color: #000000;
                font-weight: 500;
            }

            .hip-footer {
                background-color: #1a2c5b;
                padding: 0 32px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 8pt;
                color: #9ab0d8;
            }

            .hip-sig-canvas {
                display: block;
                width: 100%;
                height: 90px;
                border: 1.5px dashed #a0aec0;
                border-radius: 4px;
                background: #f8faff;
                cursor: crosshair;
                touch-action: none;
                transition: border-color 0.2s, background 0.2s;
            }

            .hip-sig-canvas:hover {
                border-color: #1a2c5b;
                background: #eef2ff;
            }

            .hip-sig-canvas.has-sig {
                border: 1.5px solid #1a2c5b;
                background: #f0f4ff;
                border-radius: 4px;
            }
        </style>

        <div class="hip-page">
            <div class="hip-header">
                <span class="hip-brand">E.A.S.Y. <span class="hip-brand-accent">Liens</span></span>
            </div>
            <div class="hip-gold-bar"></div>

            <div class="hip-body">
                <div class="hip-title">Authorization for Release of Protected Health Information</div>
                <div class="hip-subtitle">(HIPAA Waiver)</div>

                <p class="hip-p">
                    I hereby authorize any <span class="hip-bold">hospital, medical provider, health care facility, billing
                    company, or other covered entity</span> (&ldquo;Covered Entity&rdquo;) to <span class="hip-bold">disclose and release</span> the protected
                    health information described below to the following recipients:
                </p>
                <div class="hip-recipients">
                    <ul class="hip-ul" style="margin:0;">
                        <li>E.A.S.Y. Liens, LLC,</li>
                        <li>and its employees, agents, attorneys, representatives, contractors, and assigns
                            (subject to a valid Business Associates Agreement as applicable);</li>
                    </ul>
                </div>
                <p class="hip-p">(collectively, the &ldquo;Authorized Recipients&rdquo;).</p>

                <div class="hip-heading">Patient Information</div>
                <table class="hip-info-table">
                    <tr>
                        <td class="lbl">Patient Name:</td>
                        <td class="val">{{ patientName }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Date of Birth:</td>
                        <td class="val">{{ patientDob }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Last Four Digits of Social Security Number:</td>
                        <td class="val">{{ ssnLast4 }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Patient Address:</td>
                        <td class="val">{{ patientAddress }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Date(s) of Service / Incident (if applicable):</td>
                        <td class="val">{{ dateOfService }}</td>
                    </tr>
                </table>

                <div class="hip-heading">Information Authorized for Release</div>
                <p class="hip-p">This authorization applies to <span class="hip-bold">any and all protected health information</span> related
                    to the above-referenced treatment or account, including but not limited to:</p>
                <ul class="hip-ul">
                    <li>Medical records</li>
                    <li>Billing records and itemized bills and statements</li>
                    <li>Ledgers, balances, and account histories</li>
                    <li>Records relating to medical bills, liens and charges</li>
                </ul>
                <p class="hip-p">This authorization <span class="hip-bold">includes</span> information relating to HIV/AIDS, sexually
                    transmitted diseases, mental health treatment, and drug and/or alcohol treatment, <span class="hip-bold-u">only to
                    the extent such information is contained in the records described above</span>.</p>

                <div class="hip-heading">Purpose of Disclosure</div>
                <p class="hip-p">The purpose of this authorization is to allow the Authorized Recipients to
                    obtain and review medical and billing information <span class="hip-bold">in connection with
                        medical lien evaluation, negotiation, resolution, enforcement, and related
                        services</span> requested by the Patient.</p>

                <div class="hip-heading">Expiration</div>
                <p class="hip-p">This authorization shall remain valid until the <span class="hip-bold">earlier
                        of</span>:</p>
                <ul class="hip-ul">
                    <li>Final resolution and satisfaction of all medical liens related to the above-referenced
                        treatment, claim(s) and account(s); or</li>
                    <li>Five (5) years from the date of execution below.</li>
                </ul>

                <div class="hip-heading">Patient Rights</div>
                <p class="hip-p">I understand that:</p>
                <ul class="hip-ul">
                    <li>I may revoke this authorization <span class="hip-bold-u">at any time</span> by providing
                        written notice to the Covered Entity, except to the extent action has already been taken
                        in reliance on it.</li>
                    <li>I am not required to sign this authorization.</li>
                    <li>Information disclosed pursuant to this authorization may no longer be protected by
                        federal privacy regulations.</li>
                    <li>I am entitled to receive a copy of this authorization.</li>
                    <li>A copy, facsimile, or electronic version of this authorization shall be as valid as the
                        original wet version.</li>
                    <li>An electronic signature affixed by me shall be as valid as an original, wet signature.
                    </li>
                </ul>

                <div class="hip-sig-block">
                    <div class="hip-sig-block-heading">Patient Authorization</div>
                    <p class="hip-intro" style="font-weight:700;">
                        By executing below, I hereby authorize the Covered Entity to release my personally
                        identifiable health records and documents as set out and defined herein:
                    </p>
                    <table class="hip-sig-table">
                        <tr>
                            <td>
                                <span class="hip-sig-label">Printed Name</span>
                                <span class="hip-sig-value">{{ patientName }}</span>
                            </td>
                        </tr>
                    </table>
                    <table class="hip-sig-table">
                        <tr>
                            <td>
                                <span class="hip-sig-label">Patient Signature <span
                                        style="font-weight:400;text-transform:none;font-size:8pt;">(draw
                                        below)</span></span>
                                <canvas #sigCanvas class="hip-sig-canvas"
                                    [class.has-sig]="!state.isDrawEmpty"
                                    (mousedown)="mouseDown.emit($event)"
                                    (mousemove)="mouseMove.emit($event)"
                                    (mouseup)="mouseUp.emit()"
                                    (mouseleave)="mouseUp.emit()"
                                    (touchstart)="touchStart.emit($event)"
                                    (touchmove)="touchMove.emit($event)"
                                    (touchend)="touchEnd.emit()">
                                </canvas>
                            </td>
                        </tr>
                    </table>
                    <table class="hip-sig-table">
                        <tr>
                            <td>
                                <span class="hip-sig-label">Effective Date</span>
                                <div class="inline-date-picker">
                                    <app-date-picker placeholder="Select date" [showLabel]="false"
                                        [(ngModel)]="state.selectedDate"></app-date-picker>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div><!-- /.hip-body -->

            <div class="hip-footer">
                <span>E.A.S.Y. Liens, LLC &mdash; Confidential</span>
                <span>HIPAA Authorization &mdash; Page 1 of 1</span>
            </div>
        </div><!-- /.hip-page -->
    </div><!-- /.doc-card -->

</div>
